import { Message } from "./types";

export const AI_ACT_DISCLOSURE_TEXT =
  "Ciao! Sono **CaptAIn**, l’assistente virtuale di Boats Connect basato sull’intelligenza artificiale. Posso aiutarti a trovare la barca più adatta e suggerirti destinazioni in base alle tue preferenze.\n\n" +
  "Le mie risposte potrebbero contenere imprecisioni. Prima di prenotare, verifica sempre disponibilità, prezzi, condizioni di navigazione e dettagli contrattuali.";

export const createAiActDisclosureMessage = (
  timestamp: Date = new Date()
): Message => ({
  id: "ai-act-disclosure",
  isUser: false,
  text: AI_ACT_DISCLOSURE_TEXT,
  timestamp,
});
